import React from 'react'

import { SVGIcon } from '../../../wrappers/SVGIcon'

import { Icons } from '../../../../data/Assets'

interface IDocumentMetadataProps {
    fileName: string;
    onPreviewFile: () => void;
}

const DocumentMetadata = (props: IDocumentMetadataProps) => {
    const { fileName, onPreviewFile } = props;

    return (
        <div className="immersion__details_file__view">
            <div className="immersion__details_file__view__metadata">
                <div className="immersion__details_file__view__actions">
                    <button className='immersion__btn' onClick={onPreviewFile}>
                        <SVGIcon src={Icons.EyeFill} />
                        <span>{fileName}</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DocumentMetadata;